import { Recruit, Person } from '@/types'

export const metaData = [
  {
    title: '홈',
    description: '다이노스밴드는 기술과 혁신으로 더 나은 가치와 미래를 만들어갑니다.',
    keywords: ['다이노스밴드', 'dinosband'],
    author: ['다이노스밴드', 'dinosband'],
  },
  {
    title: '채용',
    description: '다이노스밴드와 혁신의 뜻을 함께할 동료를 찾습니다.',
    keywords: ['다이노스밴드', 'dinosband'],
    author: ['다이노스밴드', 'dinosband'],
  },
  {
    title: '오시는 길',
    description: '다이노스밴드 오시는길',
    keywords: ['다이노스밴드', 'dinosband'],
    author: ['다이노스밴드', 'dinosband'],
  },
  {
    title: '개인정보 취급 방침',
    description: '다이노스밴드 개인정보 취급 방침',
    keywords: ['다이노스밴드', 'dinosband'],
    author: ['다이노스밴드', 'dinosband'],
  },
]

export const recruits: Recruit[] = [
  {
    role: 'Front-end S/W 개발자',
    roleDetail: 'Web/App Front-end 개발',
    detail: `
			당사에서 개발하고 서비스하는 온라인 플랫폼 비즈플랫-구구톡의 Front-end Software를 개발합니다.
			비즈플랫-구구톡은 채팅기반 플랫폼으로서 현재는 Vue.js/Ionic 기반의 Hybrid App으로 구현되어 Web/Android/iOS를 지원합니다.
			향후에는 Native App으로 확장도 가능합니다.
		`,
    position: 'Developer',
    career: '경력무관',
    education: '학력무관',
    preference: `
			- Typescript, Vue.js, React, GraphQL 유 경험자<br>
			- 중규모 이상의 프로젝트를 스스로 설계할 수 있고 신기술에 적극적인 개발자
		`,
    state: '상시채용',
    salary: '연봉 4천만원 (4년제 대졸자 기준, 협의 가능)',
  },
  {
    role: 'Back-end S/W 개발자',
    roleDetail: 'Back-end S/W 개발 및 서버 클러스터링',
    detail: `
			당사에서 개발하고 서비스하는 온라인 플랫폼 비즈플랫-구구톡의 Back-end Software를 개발합니다.
			DataBase 서버, 실시간 메시징 서버 등 각종 서버들의 클러스터를 구성하고 서버와 Front-end를 연결하는 API를 설계하고 구현합니다.
		`,
    position: 'Developer',
    career: '경력무관',
    education: '학력무관',
    preference: `
			- Node.js, GraphQL, SQL, Kubernetes 유 경험자<br>
			- 중규모 이상의 프로젝트를 스스로 설계할 수 있고 신기술에 적극적인 개발자`,
    state: '상시채용',
    salary: '연봉 4천만원 (4년제 대졸자 기준, 협의 가능)',
  },
  {
    role: '온라인/오프라인 마케터',
    roleDetail: '온라인/SNS/오프라인 마케팅',
    detail: `
			당사에서 개발하고 서비스하는 온라인 플랫폼 비즈플랫-구구톡의 마케팅을 담당합니다.
			온라인과 SNS를 통해 홍보를 하고 고객과 소통하며 오프라인 상에서 잠재고객을 발굴하는 역할도 담당합니다.
			고객의 요구사항을 분석하여 서비스를 리드하는 기획자의 역할도 경험할 수 있습니다.`,
    position: 'Designer',
    career: '경력무관',
    education: '학력무관',
    preference: `
			- 온라인/SNS 마케팅 유 경험자<br>
			- 온라인 서비스 기획 유 경험자<br>
			- 적극적이고 고객 및 시장에 대한 이해가 뛰어난 마케터
		`,
    state: '상시채용',
    salary: '연봉 3천5백만원 (4년제 대졸자 기준, 협의 가능)',
  },
  {
    role: 'UI/UX 플랫폼 디자이너',
    roleDetail: '디자인・UI/UX・모바일',
    detail: `
			당사에서 개발하고 서비스하는 온라인 플랫폼 비즈플랫-구구톡 및 홈페이지 등 전 영역의 디자인을 담당합니다.
			웹디자인, 앱디자인, 온라인 광고 디자인, SNS 광고 디자인, 오프라인 홍보물 디자인 등 여러 분야를 경험할 수 있습니다.
		`,
    position: 'Designer',
    career: '경력무관',
    education: '학력무관',
    preference: `
			- 웹/앱 디자인 유 경험자<br>
			- 광고 디자인 유 경험자<br>
			- UI/UX에 대한 관심과 경력이 많은 디자이너<br>
		`,
    state: '상시채용',
    salary: '연봉 3천만원 (4년제 대졸자 기준, 협의 가능)',
  },
]

export const people: Person[] = [
  {
    position: 'CEO',
    name: '류병순',
    careers: [
      'KAIST 전산학 박사',
      '인공지능 전공 (컴퓨터 비전, 이동 로봇)',
      '주식회사 아이디스 공동 창업자',
      '전, 주식회사 아이디스 CTO',
      '전, Q20/20 사장',
      '전, RevoAmerica CTO',
      '전, 주식회사 아이디스 사업총괄 부사장',
      '현, 주식회사 다이노스밴드 대표',
    ],
    imageUrl: 'person-albert.png',
  },
  {
    position: 'CTO',
    name: '이은철',
    careers: [
      '포항공과대학교 전산학 석사',
      '인공지능 전공 (자연어 처리)',
      '전 삼성전자 선임 연구원',
      '전 에치디프로 연구소장',
      '현, 주식회사 다이노스밴드 연구소장',
    ],
    imageUrl: 'person-silver.png',
  },
  {
    position: 'CMO',
    name: '박흥식',
    careers: [
      '경북대학교 경영대학원',
      '마케팅 세부전공',
      '전, 주식회사 아이디스 해외 영업/마케팅',
      '현, 주식회사 다이노스밴드 마케팅 총괄',
    ],
    imageUrl: 'person-shane.png',
  },
  {
    position: 'R&D',
    name: '박효서',
    careers: [
      '홍익대학교 전자과 석사',
      '영상 신호 처리 및 압축',
      '모바일, 데스크탑 앱 개발',
      '전, 주식회사 아이디스 책임연구원',
      '전, 그루소프트 대표',
      '현, 주식회사 다이노스밴드 수석연구원',
    ],
    imageUrl: 'person-park.png',
  },
  {
    position: 'R&D',
    name: '주철',
    careers: [
      '서울대학교 물리학부 석박사 통합과정',
      '영상 보안 DB, 데이터 분석',
      '모바일, 데스크탑 앱 개발',
      '전, 주식회사 아이디스 책임연구원',
      '전, 그루소프트 수석 개발자',
      '현, 주식회사 다이노스밴드 수석연구원',
    ],
    imageUrl: 'person-joo.png',
  },
  {
    position: 'R&D',
    name: '유재혁',
    careers: [
      '한림대학교 빅데이터 학사',
      '웹/앱 프론트엔드 개발',
      '현, 주식회사 다이노스밴드 연구원',
    ],
    imageUrl: 'person-hutsu.png',
  },
]